const urlBase = `${process.env.REACT_APP_API_PROTOCOL}://${
  process.env.REACT_APP_API_HOST
}${
  process.env.REACT_APP_API_PORT ? `:${process.env.REACT_APP_API_PORT}` : ""
}/api/`;

/** AUTH **/
export const urlGetLoginItemTemp = `${urlBase}v1/items/login`;

export const urlRefreshToken = `${urlBase}v1/user/refresh-token`;
export const urlLogout = `${urlBase}v1/user/logout`;
export const urlUserSecured = `${urlBase}v1/user-s`;
export const urlUserFilterSecured = `${urlBase}v1/user-s/filter`;
export const urlUserCoreFilterSecured = `${urlBase}v1/user-s/core/filter`;
export const urlGetProfile = `${urlBase}v1/user-s/profile`;
export const urlSetNotification = `${urlBase}v1/user-s/save-subscription`;
export const urlUserCoreCreateSecured = `${urlBase}v1/user-s/core`;
export const urlChangePassCreateSecured = `${urlBase}v1/user-s/changePassword`;

// INIT VIVERO URLS
export const urlViveroSecured = `${urlBase}v1/viveros-s`;
export const urlVivero = `${urlBase}v1/viveros`;
export const urlGetAllViveroSecured = `${urlBase}v1/viveros-s/all`;

// END VIVERO URLS

// INIT VARIETY URLS
export const urlVarietySecured = `${urlBase}v1/varieties-s`;
export const urlGetAllVarietySecured = `${urlBase}v1/varieties-s/all`;
export const urlVariety = `${urlBase}v1/varieties`;
// END VARIETY URLS

// INIT BATCH URLS
export const urlBatchSecured = `${urlBase}v1/batches-s`;
export const urlBatch = `${urlBase}v1/batches`;
export const urlGetAllBatchesSecured = `${urlBase}v1/batches-s/all`;
// END BATCH URLS

// INIT TASK URLS
export const urlTaskSecured = `${urlBase}v1/tasks-s`;
export const urlGetAllTaskSecured = `${urlBase}v1/tasks-s/all`;
export const urlTask = `${urlBase}v1/tasks`;
// END TASK URLS

// INIT ARTICLE URLS
export const urlArticleSecured = `${urlBase}v1/articles-s`;
export const urlArticle = `${urlBase}v1/articles`;
export const urlGetAllArticleSecured = `${urlBase}v1/articles-s/all`;

// END ARTICLE URLS

// INIT LOCATION URLS
export const urlLocationSecured = `${urlBase}v1/locations-s`;
export const urlLocation = `${urlBase}v1/locations`;
export const urlGetAllLocationSecured = `${urlBase}v1/locations-s/all`;
// END LOCATION URLS

// INIT SECTOR URLS
export const urlSectorSecured = `${urlBase}v1/sectors-s`;
export const urlSector = `${urlBase}v1/sectors`;
export const urlGetAllSectorsSecured = `${urlBase}v1/sectors-s/all`;
// END SECTOR URLS

// INIT CODE URLS
export const urlCodeSecured = `${urlBase}v1/codes-s`;
export const urlGetAllCodeSecured = `${urlBase}v1/codes-s/all`;
export const urlCode = `${urlBase}v1/codes`;
// END CODE URLS

// INIT WORKING_PART URLS
export const urlWorkingPartSecured = `${urlBase}v1/workingParts-s`;
export const urlMyWorkingPartSecured = `${urlBase}v1/workingParts-s/my`;
export const urlWorkingPart = `${urlBase}v1/workingParts`;
export const urlDailyPartSecured = `${urlBase}v1/workingParts-s/daily`;
export const urlValidateWorkingPartSecured = `${urlBase}v1/workingParts-s/validate`;
export const urlConfirmWorkingPartSecured = `${urlBase}v1/workingParts-s/confirm`;
export const urlConfirmAllWorkingPartSecured = `${urlBase}v1/workingParts-s/confirmAll`;
export const urlExportDailyPartSecured = `${urlBase}v1/workingParts-s/exportDaily`;
export const urlExportWorkingPartSecured = `${urlBase}v1/workingParts-s/exportWorking`;
export const urlReportTaskHourSecured = `${urlBase}v1/workingParts-s/taskHourReport`;
export const urlAdmWorkingPartSecured = `${urlBase}v1/workingParts-s/adm`;
export const urlRemoveDailyWorkingPartSecured = `${urlBase}v1/workingParts-s/daily/remove`;
export const urlUpdateDateSecured = `${urlBase}v1/workingParts-s/updateDate`;
export const urlWorkingPartUnitsSecured = `${urlBase}v1/workingParts-s/allWorkingParts`;
// END WORKING_PART URLS

// INIT WORKING_PART URLS
export const urlMermaPartSecured = `${urlBase}v1/mermaParts-s`;
export const urlMyMermaPartSecured = `${urlBase}v1/mermaParts-s/my`;
export const urlMermaPart = `${urlBase}v1/mermaParts`;
export const urlExportMermaPartSecured = `${urlBase}v1/mermaParts-s/export`;

// END WORKING_PART URLS

/* GENERATOR_INJECT_URLS */
export const urlProviderSecured = `${urlBase}v1/Providers-s`;
export const urlProvider = `${urlBase}v1/Providers`;
export const urlGetAllProviderSecured = `${urlBase}v1/Providers-s/all`;